import Vue from 'vue'
import VueLocalStorage from 'vue-localstorage'
Vue.use(VueLocalStorage, {
  name: 'ls',
  bind: true
})

export default {
  lang: {
    type: String,
    default: 'ru'
  },
  token: {
    type: String
  },
  user_id: {
    type: Number
  },
  email: {
    type: String,
    default: 'admin@admin.com'
  },
  history: {
    type: Array
  },
  device: {
    type: Number,
    default: 0
  },
  group: {
    type: Number,
    default: 0
  },
  mapCenter: {
    type: Object,
    default: {
      lat: 55.752526,
      lng: 37.620012,
      alt: 'Moscow'
    }
  },
  objectOptions: {
    type: Object,
    default: {
      visible: true,
      history_points: false,
      geozones: false
    }
  },
  currentTile: {
    type: String,
    default: 'wiki'
  },
  mapZoom: {
    type: Number,
    default: 10
  }
}



// WEBPACK FOOTER //
// ./src/localstore/index.js